import { render, staticRenderFns } from "./DossierDiagnosisPanel.vue?vue&type=template&id=29dce7d0&scoped=true"
import script from "./DossierDiagnosisPanel.vue?vue&type=script&lang=ts"
export * from "./DossierDiagnosisPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dce7d0",
  null
  
)

export default component.exports